import { render } from "./ProjectCommentField.vue?vue&type=template&id=347b4aeb"
import script from "./ProjectCommentField.vue?vue&type=script&lang=js"
export * from "./ProjectCommentField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__